/**
 * WordPress dependencies
 */
import { store } from '@wordpress/interactivity';

// Check for system dark mode preference and store to use in init callback
const prefersDarkScheme = window.matchMedia( '(prefers-color-scheme: dark)' );

const { callbacks, state } = store( 'interplay-toggle-colour-scheme', {
	state: {
		get catsText() {
			return state.isCats ? state.removeCatsText : state.addCatsText;
		},
		get catImageURL() {
			return state.isCats ? state.removeCatsText : state.addCatsText;
		},
	},
	
	actions: {
		
		enableLightMode() {
			state.isDark = false;
			state.colorScheme = 'light';
			
			// Define the cookie path and domain.
			let path   = state.cookiePath || '/';
			let domain = state.cookieDomain ? "; domain=" + state.cookieDomain : '';
			// Set cookie called cookieNameScheme to colorScheme value
			document.cookie = `${state.cookieNameScheme}=${state.colorScheme};path=${path}${domain}`;
		},
		enableDarkMode() {
			state.isDark = true;
			state.colorScheme = 'dark';
			
			// Define the cookie path and domain.
			let path   = state.cookiePath || '/';
			let domain = state.cookieDomain ? "; domain=" + state.cookieDomain : '';

			// Set cookie called cookieNameScheme to colorScheme value
			document.cookie = `${state.cookieNameScheme}=${state.colorScheme};path=${path}${domain}`;
		},
		toggleCats() {
			// Toggle the isCats state
			state.isCats = ! state.isCats;
			state.catExistence = state.isCats ? 'cats' : 'nocats';

			// Define the cookie path and domain.
			let path   = state.cookiePath || '/';
			let domain = state.cookieDomain ? "; domain=" + state.cookieDomain : '';

			// Set cookie called cookieNameCats to catExistence value
			document.cookie = `${state.cookieNameCats}=${state.catExistence};path=${path}${domain}`;
		},
	},
	callbacks: {
		init() {
			// Check if our color scheme preference cookie is already set
			if ('dark' === state.colorScheme || 'light' === state.colorScheme) {
				return;
			}
			// If our cookie isn't set, Set isDark based on user preference
			state.isDark = prefersDarkScheme.matches;
		},
		updateScheme() {
			// Apply the color scheme to the document
			document.documentElement.style.setProperty(
				'color-scheme',
				state.colorScheme
			);
			// Apply cat/noCat class to body
			document.body.classList.toggle('cats', state.isCats);
			document.body.classList.toggle('noCats', !state.isCats);
		
		}
	}
	
} );

// in case user changes system theme preference after page init
prefersDarkScheme.addEventListener( 'change', () => {
	callbacks.init();
} );
